// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"4360ba93","447":"16554d1a","702":"dc148c75","860":"99249549","999":"884affab"}[chunkId] + ".css";
};